import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import messages from './messages';
import style from './style.module.less';
import { pages } from '../settings/nav-items';

const ConfirmModalBody = () => {
  return (
    <div>
      <h4>
        <FormattedMessage {...messages.hideConfirmationBodyHeader} />
      </h4>
      <p>
        <FormattedMessage
          {...messages.hideConfirmationBody}
          values={{
            linkAndIcon: (chunks) => (
              <Link to={pages.settings.location}>
                {chunks}
                <FontAwesomeIcon className={style.icon} icon={faGear} />
              </Link>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default ConfirmModalBody;
